import { createInstance } from "i18next";

import { baseI18nConfig } from "@shared/locales/baseI18nConfig";

import { en } from "./en";

const i18n = createInstance();
i18n.init({
  ...baseI18nConfig,
  ns: ["oauth", "credentials"],
  defaultNS: "oauth",
  fallbackNS: "oauth",
  resources: {
    en,
  },
});

const l = en;

export { i18n, l };
